import React, { FC, memo, useCallback, useEffect, useState } from 'react';
import { getActions } from '../../global';

import type { TabState } from '../../global/types';

import useFlag from '../../hooks/useFlag';

import RecipientPicker from '../common/RecipientPicker';
import { useTranslation } from 'react-i18next';

export type OwnProps = {
  requestedShare: TabState['requestedShare'];
};

const ShareRecipientPicker: FC<OwnProps> = ({ requestedShare }) => {
  const isOpen = Boolean(requestedShare);
  const { resetOpenChatWithDraft } = getActions();

  const { t } = useTranslation();

  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  const [isShown, markIsShown, unmarkIsShown] = useFlag();
  useEffect(() => {
    if (isOpen) {
      markIsShown();
    }
  }, [isOpen, markIsShown]);

  const handleSelectRecipient = useCallback(
    (id: string) => {
      const newSelectedIds = [...selectedIds];
      if (newSelectedIds.includes(id)) {
        newSelectedIds.splice(newSelectedIds.indexOf(id), 1);
      } else {
        newSelectedIds.push(id);
      }
      setSelectedIds(newSelectedIds);
    },
    [selectedIds, setSelectedIds]
  );

  const handleClose = useCallback(() => {
    resetOpenChatWithDraft();
    setSelectedIds([]);
  }, [resetOpenChatWithDraft]);

  if (!isOpen && !isShown) {
    return undefined;
  }

  return (
    <RecipientPicker
      isOpen={isOpen}
      searchPlaceholder={t('SearchTo')}
      onSelectRecipient={handleSelectRecipient}
      onClose={handleClose}
      onCloseAnimationEnd={unmarkIsShown}
      selectedIds={selectedIds}
    />
  );
};

export default memo(ShareRecipientPicker);
